module.exports = __webpack_public_path__ + "static/media/noburoall.6e672e92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/noburoall.jpg
// module id = 843
// module chunks = 0